export default __webpack_public_path__ + "resources/icons/d321-6f51.png";